import { BUCKET_NAME, CLOUD_FRONT_URL } from "../conf";
import { Buffer } from "buffer";

const getImgUrl = (
	product,
	width = false,
	height = false,
	remoteKey = "",
	edits = {}
) => {
	if (!product) return "";

	// If an alternativeKey is passed, it will be read from that field instead of image_key
	const key = product.image_key;

	if (!key) {
		return remoteKey ? product[remoteKey] : product.photo_url;
	}

	const imgPayload = JSON.stringify({
		bucket: BUCKET_NAME,
		key,
		edits: {
			...edits,
			resize: {
				width: width || 350,
				height: height || 350,
				...(edits?.resize || {}),
			},
		},
	});

	const buff = Buffer.from(imgPayload, "utf8");
	return `${CLOUD_FRONT_URL}/${buff.toString("base64")}`;
};

export default getImgUrl;
